export const moneyToInteger = (value: number) => {
  if (!value) {
    return 0
  }

  return Math.round(value * 100)
}

export const integerToMoney = (value: number) => {
  if (!value) {
    return 0
  }

  return parseFloat((value / 100).toFixed(2))
}
